import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isNumber } from "typeGuards/isNumber";
import { DEFAULT_PAGINATION_LIMIT } from "../../constants";
import {
  GetNewsFeedPostsParams,
  GetNewsFeedPostsResponse,
  NewsFeedPost
} from "./types";

export type NewsState = {
  posts: { data: NewsFeedPost[]; hasMore: boolean } | null;
  arePostsLoading: boolean;
  arePostsMarkingAsRead: boolean;
};

const initialState: NewsState = {
  posts: null,
  arePostsLoading: false,
  arePostsMarkingAsRead: false
};

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    // Get News Feed Posts
    getNewsFeedPostsRequest: (
      state,
      action: PayloadAction<GetNewsFeedPostsParams>
    ) => {
      state.arePostsLoading = true;
    },
    getNewsFeedPostsSuccess: (
      state,
      action: PayloadAction<{
        params: GetNewsFeedPostsParams;
        result: GetNewsFeedPostsResponse;
      }>
    ) => {
      const { params, result } = action.payload;
      state.posts = {
        data: [
          ...((isNumber(params.offset) || isNumber(params.lastId)) &&
          state.posts
            ? state.posts.data
            : []),
          ...result.data
        ],
        hasMore:
          result.data.length >= (params.limit || DEFAULT_PAGINATION_LIMIT)
      };
      state.arePostsLoading = false;
    },
    getNewsFeedPostsFailure: (
      state,
      action: PayloadAction<{ params: GetNewsFeedPostsParams; error: string }>
    ) => {
      state.arePostsLoading = false;
    },

    // Mark News Feed Posts As Read
    markNewsFeedPostsAsReadRequest: (state) => {
      state.arePostsMarkingAsRead = true;
    },
    markNewsFeedPostsAsReadSuccess: (state) => {
      state.arePostsMarkingAsRead = false;
    },
    markNewsFeedPostsAsReadFailure: (
      state,
      action: PayloadAction<{ error: string }>
    ) => {
      state.arePostsMarkingAsRead = false;
    },

    // Clear
    clear: () => initialState
  }
});

export const {
  getNewsFeedPostsRequest,
  getNewsFeedPostsSuccess,
  getNewsFeedPostsFailure,
  markNewsFeedPostsAsReadRequest,
  markNewsFeedPostsAsReadSuccess,
  markNewsFeedPostsAsReadFailure,
  clear
} = newsSlice.actions;

export const { actions: newsActions } = newsSlice;

export const reducer = newsSlice.reducer;
